import React, { useContext } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import './Contactus.scss';
import ContactForm from '../../components/ContactForm/ContactForm';
import InstagramShowcase from '../../components/InstagramShowcase/InstagramShowcase';
import Footer from '../../sections/Footer/Footer';
import { LanguageContext } from '../../context/LanguageContext';
import PageTitleContact from '../../components/PageTitleContact/PageTitleContact';
import MetaHelmet from '../../components/SEO/MetaHelmet';

const Contactus = () => {
    const { t } = useContext(LanguageContext);

    return (
        <>
            <MetaHelmet pageName="contact" />
            <section className='section-bg section-common contact-section'>
                <Navbar />
                <PageTitleContact 
                    title={t('contact.title')}
                    description={t('contact.description')}
                />
            </section>
            <section className='contact-form-area' data-aos="fade-up" data-aos-duration="1500" data-aos-once="true" data-aos-offset="100">
                <ContactForm />
            </section>
            <InstagramShowcase />
            <Footer />
        </>
    );
};

export default Contactus;